/*
Rajesh 11/23/2022 2699234404 added copy functionality
Rajesh 11/25/2022 2699234404 added validation for jobName
Dilip 11/29/2022  2699234404 copy functionality payload change
Rajesh 12/01/2022 2699234404 label and placeholder changes
Dilip 12/02/2022 2699234404 Added validation for job description
Sai maheshwar 12/06/2022  2699234404 removed job name while copy job
lalitha 12/13/2022 2699234404 Added reusable Validation on code
Saikrishna 12/18/2022 3225736869 Fixed jira bugs by QA on night jobs
akhila 12/23/2022 3225736869 fixed job code and description validation issues
sai krisha 30/12/2022 3225736869 add code description values
kavyareddy 1/04/2023 3225736869 Fixed jobCode validation issue
suresh peddavoora 03/06/2023 3225736869 new UI changes
sohel 03/06/2023 3225736869 Added validation message for existing value
Akhila 06/13/2023 3225736869 Added code and description
*/
import React, {useContext, useEffect} from 'react';
import {Formik} from 'formik';
import {Button, FormHelperText, Grid, TextField} from '@material-ui/core';
import ErrorBoundaryForComponents from '../../../../../util/ErrorBoundaryForComponents';
import * as Yup from 'yup';
import {ThemeContext} from '../../../../../themes/ThemeProvider';
import {useDispatch, useSelector} from 'react-redux';
// import {nameWithSpecialCharacter} from '../../../../../util/Content';
// import {nameRegexAllow} from '../../../../../util/RegexPatterns';
import PageLoader from './../../../../../components/PageLoader/index';
import {
  postCopyNightJob,
  resetCopyNightJob,
  fetchAllJobCodesAndJobNames,
} from '../../../../../redux/reducers/NightJobs/AddNightJob';
import {SuccessSnackbar} from '../../../../../components/CustomSnackBar';
import BreadCrums from '../../../../../util/BreadCrum';
const CopyNightJob = ({copyOldJob, handleCopyNightJob}) => {
  const {reusableInputStyles} = useContext(ThemeContext);
  const {isLoading, successMsg, copyNightJobStatus, allJobCodesAndJobNames} = useSelector(
    ({addNightJob}) => addNightJob,
  );
  const classes = reusableInputStyles();
  const dispatch = useDispatch();
  const initialValues = {
    jobCode: '',
    jobName: '',
    jobDescription: '',
  };
  useEffect(() => {
    dispatch(fetchAllJobCodesAndJobNames());
  }, []);

  const checkJobCodeExist = (value) => {
    if (allJobCodesAndJobNames && allJobCodesAndJobNames?.length > 0 && value) {
      const ar = [];
      allJobCodesAndJobNames?.filter((i) => {
        if ((i?.jobCode?.toUpperCase()?.trim() === value?.toUpperCase()?.trim()) && i?.isActive === 'Y') {
          ar.push(i);
        }
      });
      return ar.length > 0;
    } else {
      return false;
    }
  };
  const checkJobCodeAlreadyExist = (value) => {
    if (allJobCodesAndJobNames && allJobCodesAndJobNames?.length > 0 && value) {
      const ar = [];
      allJobCodesAndJobNames?.filter((i) => {
        if ((i?.jobCode?.toUpperCase()?.trim() === value?.toUpperCase()?.trim()) && i?.isActive === 'N') {
          ar.push(i);
        }
      });
      return ar.length > 0;
    } else {
      return false;
    }
  };

  const schema = Yup.object().shape({
    jobCode: initialValues.jobCode ?
      null :
      Yup.string()
        .required('Job Name is required')
        .max(25, 'Job Name cannot exceed 25 characters')
        .test('jobCode', 'Job Name already in use', (value) => !checkJobCodeExist(value))
        .test(
          'jobCode',
          'Job Name has already been used in the past',
          (value) => !checkJobCodeAlreadyExist(value),
        )
        .max(25, 'Job Name cannot exceed 25 characters'),
    // .test('jobCode', 'Multiple hyphen(-) are not allowed', (value) => {
    //   if (value?.slice(-2) === '--') {
    //     return false;
    //   } else {
    //     return true;
    //   }
    // })
    // .matches(nameRegexAllow, nameWithSpecialCharacter),
    // jobName: Yup.string()
    //   .required("Job name is required")
    //   .matches(/^[a-zA-Z0-9]+$/, "White spaces and special characters are not allowed")
    //   .test("jobName", "Job name already exist", (value) => !checkJobNameExist(value)),
    jobDescription: Yup.string()
      .required('Job Description is required')
      .max(100, 'Job Description cannot exceed 100 characters'),
  });

  const handleSubmit = (values) => {
    if (values) {
      const data = {
        jobCode: values?.jobCode ? values?.jobCode : '',
        oldJobCode: copyOldJob.jobCode,
        oldjobId: copyOldJob.jobId,
        jobName: values?.jobName ? values?.jobName : '',
        jobDescription: values?.jobDescription ? values?.jobDescription : '',
      };
      dispatch(postCopyNightJob(data));
    }
  };
  useEffect(() => {
    if (copyNightJobStatus === 200) {
      handleCopyNightJob();
      setTimeout(() => {
        dispatch(resetCopyNightJob());
      }, 3000);
    }
  }, [copyNightJobStatus]);
  //   useEffect(() => {
  //     dispatch(getAllReportCodeData());
  //   }, []);
  return (
    <>
      <div className={classes.addRule}>
        <div className={classes.dialoguecardStyles}>
          <Formik
            onSubmit={(values) => handleSubmit(values)}
            initialValues={initialValues}
            validationSchema={schema}
            enableReinitialize
            validateOnChange
          >
            {(props) => {
              const {
                values,
                handleSubmit,
                handleReset,
                handleChange,
                touched,
                errors,
                resetForm,
                handleBlur,
              } = props;
              return (
                <div>
                  <BreadCrums
                    name={'Name'}
                    code={copyOldJob?.jobCode}
                    description={'Description'}
                    descriptionValue={copyOldJob?.jobDescription}
                  />
                  <form autoComplete="off" noValidate onSubmit={handleSubmit} onReset={handleReset}>
                    <div className="global-field-textfields new-standard-textfields">
                      <ErrorBoundaryForComponents>
                        <Grid container spacing={2}>
                          <Grid item xs={6} className={`${errors?.jobCode?.length > 30 ? 'form-group-lg' : 'form-group'}`}>
                            <TextField
                              // className={` ${classes.labelName} ${classes.inputLabel}`}
                              placeholder="Enter Job Name"
                              margin="dense"
                              name="jobCode"
                              variant="outlined"
                              value={values?.jobCode}
                              label="Job Name"
                              // InputLabelProps={{
                              //   shrink: true,
                              // }}
                              required
                              inputProps={{maxLength: 25}}
                              onBlur={handleBlur}
                              onChange={handleChange}
                              touched={touched.jobCode}
                              error={Boolean(errors.jobCode && touched.jobCode)}
                              fullWidth
                            />
                            <FormHelperText style={{color: 'red'}} variant="outlined">
                              {touched.jobCode && errors.jobCode}
                            </FormHelperText>
                          </Grid>
                          {/* <Grid item xs={6} className="form-group">
                            <TextField
                              className={` ${classes.labelName} ${classes.inputLabel}`}
                              placeholder="Enter Job Name"
                              margin="dense"
                              name="jobName"
                              value={values.jobName}
                              variant="outlined"
                              label="Job Name"
                              InputLabelProps={{
                                shrink: true,
                              }}
                              onBlur={handleBlur}
                              onChange={handleChange}
                              touched={touched.jobName}
                              required
                              error={Boolean(errors.jobName && touched.jobName)}
                              fullWidth
                            />
                            <FormHelperText variant="outlined">
                              {touched.jobName && errors.jobName}
                            </FormHelperText>
                          </Grid> */}
                          <Grid item xs={6} className="form-group">
                            <TextField
                              // className={` ${classes.labelName} ${classes.inputLabel}`}
                              placeholder="Enter Job Description"
                              margin="dense"
                              name="jobDescription"
                              value={values.jobDescription}
                              variant="outlined"
                              label="Job Description"
                              inputProps={{maxLength: 100}}
                              // InputLabelProps={{
                              //   shrink: true,
                              // }}
                              onBlur={handleBlur}
                              onChange={handleChange}
                              touched={touched.jobDescription}
                              required
                              error={Boolean(errors.jobDescription && touched.jobDescription)}
                              fullWidth
                            />
                            <FormHelperText variant="outlined">
                              {touched.jobDescription && errors.jobDescription}
                            </FormHelperText>
                          </Grid>
                        </Grid>
                      </ErrorBoundaryForComponents>
                    </div>
                    <div className="button-spacing-mb new-standard-textfields">
                      <Button
                        variant="outlined"
                        onClick={() => {
                          resetForm(initialValues);
                        }}
                        className={`reset-btn mr-1 ${classes.buttonRoot}`}
                      >
                        Reset
                      </Button>
                      <Button
                        variant="outlined"
                        type="submit"
                        className={`search-btn ml-1 ${classes.buttonRoot}`}
                      >
                        Copy
                      </Button>
                    </div>
                  </form>
                </div>
              );
            }}
          </Formik>
        </div>
      </div>
      {isLoading && <PageLoader />}
      {successMsg && <SuccessSnackbar successMsg={successMsg} />}
    </>
  );
};

export default CopyNightJob;
